import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Transaction } from "model";
/**
* @class RegularTransaction
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.regularTransaction[0];
* const transaction = new RegularTransaction(record);
* @property {NUMBER} _mapID - The id of the transaction related account data
*/
export default class RegularTransaction extends BCMSRecord{
    _mapID;    
    constructor (record){   
      super(Object.assign(record,Transaction.initByID(record.mapID).record))   
    }
  } 
  RegularTransaction.define({
    "recordType":"regularTransactions",
    "recordIDProp":"mapID",
    "className" : "RegularTransaction",
    "recordProperties": [
      /** 
      * @name mapID
      * @instance
      * @property get {NUMBER} - gets the mapID of the transaction
      * @property set {NUMBER} - sets the imapIDd of the transaction
      * @memberof RegularTransaction 
      */
      BCMSRecordProperty.mapToNumber("mapID","_mapID")
    ].concat(Transaction._RecordProperties)
})




